import { GraphQLError } from "graphql"

import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"
import { AppSettings } from "@/settings"
import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const mutationUpdatePicklist = {
  async updatePicklist(_parent, args, context, _info) {
    const { lang = AppSettings.defaultLocale(), cdn = false, orderNumber, branchId, articleData } = args
    const { sanityClient: client, user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.PICKLISTS,
      operation: Operations.UPDATE,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    client.config({ ...config, useCdn: cdn })

    const activePicklist = await getPicklistFromArchive({ orderNumber })
    if (!activePicklist) {
      throw new Error("Picklist not found")
    }

    if (!activePicklist.picklist) {
      throw new Error("The order is no longer a picklist")
    }

    if (String(activePicklist.branchNumber ?? "") !== String(branchId)) {
      throw new GraphQLError("Picklist can only be completed when the document branch is logged in", {
        extensions: { code: "NOT_ALLOWED" },
      })
    }

    const doc = {
      _type: "picklist",
      customerNumber: activePicklist?.customerNumber,
      lineItems: articleData?.map(({ posId, number, amount, createAdditionalDelivery }) => {
        return {
          _key: posId,
          position: Number(posId),
          sku: number,
          quantity: Number(amount),
          createAdditionalDelivery,
        }
      }),
      modificationSource: "Sanity",
      admNumber: user.employeeNumber,
      picklistNumber: activePicklist?.orderNumber,
      picklist: false,
    }

    try {
      const insertPicklistUpdate = await client.create(doc)
      return { id: insertPicklistUpdate?._id }
    } catch (error) {
      throw new Error(error.message)
    }
  },
}

/**
 * @param {{orderNumber: string}}
 * @returns {object}
 */
const getPicklistFromArchive = async ({ orderNumber }) => {
  const graphiQLQueryObject = [
    {
      method: "findOrder",
      variables: { orderNumber },
      fields: ["orderNumber", "customerNumber", "admNumber", "picklist", "branchNumber"],
    },
  ]

  const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)
  const picklistResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data?.findOrder

  return picklistResponse
}
